module.exports = __webpack_public_path__ + "static/media/全国“名特优新”个体工商户培育平台_个体工商户申报手册.6dc9153a.pdf";